import React, { useRef, useState, useEffect } from "react";
import { aboutUsContent } from "../../data/aboutUsContent";
import { FadeInFromBottomSection } from "../../utils/AboutUsFadeEffects";

export default function AboutContentCard() {
    const about = aboutUsContent;

    return(
        <>
            {/* "About Us" title (upwards fade—bottom) */}
            <FadeInFromBottomSection className="-mt-4 sm:-mt-16 lg:-mt-20 pt-8 pb-4 max-w-6xl mx-4 sm:mx-6 md:mx-4 lg:mx-auto px-6 sm:px-6 md:px-10 backdrop-blur-[32px] bg-white bg-opacity-90 rounded-xl shadow-md font-sans select-none">
                <h2 className="text-4xl font-bold text-sky-600 mb-12 text-center font-heading py-4">About Us</h2>
                {about.map((paragraph, index) => (
                    <p 
                        key={index}
                        className="text-gray-700 text-lg leading-relaxed mb-6 tracking-wide text-left  mb-4 max-w-4xl mx-auto">
                        {paragraph}
                    </p>
                ))}
            </FadeInFromBottomSection>
        </>
    )
}